import React, { useEffect, useState } from "react";
import { Paper, IconButton, Tooltip, Chip, Avatar } from "@mui/material";
import MUIDataTable from "../../../components/LegacyMuiDataTable";
import EditIcon from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import { useSelector, useDispatch } from "react-redux";
import { green, red } from "@mui/material/colors";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";
import { useSnackbar } from "notistack";

import { getMenuItems, deleteMenuItem } from "../../../store/ducks/duckMenuItem";
import NavBar from "../../../components/Navbar";
import { getGroups } from "../../../store/ducks/duckGroups";
import { getLayouts } from "../../../store/ducks/duckLayout";
import { useStylesLayout } from "../../../styles/Layout";
import { BorderLinearProgress } from "../../../components/LoadingComponent";
import ConfirmDelete from "../../../components/confirmDelete";
import MaxChips from "../../../components/MaxChips";
import CustomToolbar from "../../../components/CustomToolbar";

import MenuItemForm from "./components/MenuItemForm";

const MenuItem = () => {
  const data = useSelector((state) => state.menuItem.data);
  const loading = useSelector((state) => state.menuItem.isLoading);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const [isCollection, setIsCollection] = useState(false);
  const classes = useStylesLayout();
  const menuItemGroups = useSelector((state) => state.groups.data);
  const layouts = useSelector((state) => state.layout.dataLayout);

  const getMenuItemName = (id) => data.find((x) => x.id === id)?.name ?? "";
  const getParentMenuItemName = (id) => data.find((x) => x.id === id)?.name ?? "None";
  const getGroupName = (id) => menuItemGroups.find((x) => x.id === id)?.name ?? "None";
  const getLayoutName = (id) => layouts.find((x) => x.id === id)?.name ?? "None";

  const { enqueueSnackbar } = useSnackbar();

  const [menuItemSelected, setMenuItemSelected] = useState({
    id: 0,
    name: "",
    description: "",
    order: 0,
    layout: {},
    parentMenuItemId: null,
    icon: "",
    childrens: [],
    layoutId: null,
    groups: [],
    public: true,
    deleted: false,
    internalLink: "",
    isInternal: false,
    isCollection: false,
  });

  const [isEdit, setEdit] = useState(false);

  const [openConfirm, setOpenConfirm] = useState(false);

  useEffect(() => {
    dispatch(getGroups());
    dispatch(getMenuItems());
    dispatch(getLayouts());
  }, [dispatch]);

  const handleClickReload = () => {
    dispatch(getGroups());
    dispatch(getMenuItems());
    dispatch(getLayouts());
  };

  const handleClickOpen =
    (menuItem, isEdit = true) =>
    (event) => {
      event.preventDefault();
      setEdit(isEdit);
      if (menuItem) {
        setMenuItemSelected(menuItem);
      } else {
        setMenuItemSelected({
          id: 0,
          name: "",
          description: "",
          order: 0,
          layout: {},
          parentMenuItemId: null,
          icon: "",
          childrens: [],
          layoutId: 0,
          groups: [],
          isCollection: false,
        });
      }

      setOpen(true);
    };

  const handleClickOpenCollection =
    (menuItem, isEdit = true) =>
    (event) => {
      event.preventDefault();
      setIsCollection(true);
      setEdit(isEdit);
      if (menuItem) {
        setMenuItemSelected(menuItem);
      } else {
        setMenuItemSelected({
          id: 0,
          name: "",
          description: "",
          order: 0,
          layout: {},
          parentMenuItemId: null,
          icon: "",
          childrens: [],
          layoutId: 0,
          groups: [],
          isCollection: true,
        });
      }

      setOpen(true);
    };

  const handleClose = () => {
    setOpen(false);
    setIsCollection(false);
  };
  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleConfirm = (menuItemSelected) => (event) => {
    event.preventDefault();
    setMenuItemSelected(menuItemSelected);

    setOpenConfirm(true);
  };

  const handleDelete = (event) => {
    event.preventDefault();
    dispatch(deleteMenuItem(menuItemSelected.id)).then(() =>
      enqueueSnackbar(`MenuItem ${menuItemSelected.name} Deleted succesfully`, {
        variant: "info",
      }),
    );
    handleCloseConfirm();
  };

  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: true,
        display: false,
        customFilterListOptions: {
          render: (v) => getMenuItemName(v),
        },
        filterOptions: {
          renderValue: (v) => getMenuItemName(v),
        },
      },
    },
    {
      name: "deleted",
      label: "Deleted",
      options: {
        filter: true,
        display: false,
        customFilterListOptions: { render: (v) => `Deleted: ${v}` },
        filterList: [false],
        filterOptions: {
          renderValue: (v) => `${v}`,
        },
      },
    },
    {
      name: "isCollection",
      label: "Collection",
      options: {
        filter: true,
        display: false,
        customFilterListOptions: { render: (v) => `Collection: ${v}` },
        customBodyRenderLite: (dataIndex) => {
          let isPublic = data[dataIndex].isCollection;

          return <>{isPublic ? <CheckIcon /> : <RemoveIcon />}</>;
        },
        filterOptions: {
          renderValue: (v) => `${v}`,
        },
      },
    },
    {
      name: "parentMenuItemId",
      label: "Parent",
      options: {
        filter: true,
        customFilterListOptions: {
          render: (v) => `Parent: ${getParentMenuItemName(v)}`,
        },
        filterOptions: {
          renderValue: (v) => {
            return getParentMenuItemName(v);
          },
        },
        customBodyRenderLite: (dataIndex) => {
          let parentId = data[dataIndex]?.parentMenuItemId;
          let parent = parentId ? data.find((x) => x.id === parentId) : null;
          let childrensCount = data.filter((obj) => parentId === obj.parentMenuItemId).length;

          return (
            <>
              {parent && (
                <Tooltip title={`Parent: ${parent.name}, Childrens: ${childrensCount}`}>
                  <Chip
                    avatar={
                      <Avatar
                        style={{
                          color: green[700],
                          backgroundColor: green[300],
                        }}
                      >
                        {parent.name.slice(0, 1)}
                      </Avatar>
                    }
                    className={classes.chipLayouts}
                    label={parent.name}
                    size="small"
                    variant="outlined"
                  />
                </Tooltip>
              )}
            </>
          );
        },
        sortDirection: "asc",
        sortThirdClickReset: true,
        sortDescFirst: true,
        sortCompare: (order) => {
          const ParentIdPosition = 2;

          return ({ rowData: rowData1 }, { rowData: rowData2 }) => {
            let firstParentId = rowData1[ParentIdPosition];
            let secondParentId = rowData2[ParentIdPosition];

            let firstParentName = data.find((x) => x.id === firstParentId)?.name;
            let secondParentName = data.find((x) => x.id === secondParentId)?.name;

            if (firstParentName === undefined || firstParentName === null) return -1;
            if (secondParentName === undefined || secondParentName === null) return 1;

            if (order === "asc") {
              return firstParentName > secondParentName ? 1 : -1;
            } else if (order === "desc") {
              return firstParentName < secondParentName ? 1 : -1;
            } else {
              return 1;
            }
          };
        },
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
      },
    },
    {
      name: "description",
      label: "Description",
      options: {
        filter: true,
      },
    },
    {
      name: "order",
      label: "Order",
      options: {
        filter: true,
      },
    },
    {
      name: "public",
      label: "Public",
      options: {
        filter: true,
        customBodyRenderLite: (dataIndex) => {
          let isPublic = data[dataIndex].public;

          return <>{isPublic ? <CheckIcon /> : <RemoveIcon />}</>;
        },
      },
    },
    {
      name: "groups",
      label: "Groups",
      options: {
        filter: true,
        customBodyRenderLite: (dataIndex) => {
          let groupsRow = data[dataIndex].groups;
          let isPublic = data[dataIndex].public;

          if (groupsRow.length === 0 || isPublic) return <></>;

          return (
            <MaxChips key={`Wrapper-MaxChips-${dataIndex}`} maxChips={3}>
              {groupsRow.map((row, i) => (
                <Tooltip
                  key={`tooltip-chip-${row}-${i}`}
                  title={menuItemGroups && menuItemGroups?.find((x) => x.id === row)?.name}
                >
                  <Chip
                    label={
                      menuItemGroups && menuItemGroups?.find((x) => x.id === row)?.name.slice(0, 1)
                    }
                    size="small"
                    style={{
                      color: red[900],
                      borderColor: red[300],
                      margin: 3,
                    }}
                    variant="outlined"
                  />
                </Tooltip>
              ))}
            </MaxChips>
          );
        },
        customFilterListOptions: {
          render: (v) => `Group: ${getGroupName(v)}`,
        },
        filterOptions: {
          renderValue: (v) => `${getGroupName(v)}`,
        },
      },
    },
    {
      label: "Layout",
      name: "layoutId",
      options: {
        filter: true,
        customBodyRenderLite: (dataIndex) => {
          let layout = data[dataIndex]?.layout;

          return (
            <>
              {layout && layout.name && (
                <Chip
                  avatar={
                    <Avatar style={{ color: green[700], backgroundColor: green[300] }}>
                      {layout?.name.slice(0, 1)}
                    </Avatar>
                  }
                  className={classes.chipLayouts}
                  label={layout?.name}
                  size="small"
                  variant="outlined"
                />
              )}
            </>
          );
        },
        customFilterListOptions: {
          render: (v) => `Layout: ${getLayoutName(v)}`,
        },
        filterOptions: {
          renderValue: (v) => `${getLayoutName(v)}`,
        },
      },
    },
    {
      label: "Icon",
      name: "icon",
      options: {
        filter: true,
        customBodyRenderLite: (dataIndex) => {
          let icon = data[dataIndex]?.icon;

          return (
            icon && (
              <Tooltip title={icon}>{icon && <i className="material-icons">{icon}</i>}</Tooltip>
            )
          );
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        viewColumns: false,
        customBodyRenderLite: (dataIndex) => {
          let rowData = data[dataIndex];

          return (
            <div style={{ maxWidth: 250 }}>
              <Tooltip title={"Edit"}>
                <IconButton aria-label="edit" size="small" onClick={handleClickOpen(rowData, true)}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={rowData.deleted ? "Is already removed" : "Delete"}>
                <IconButton
                  aria-label="delete"
                  disabled={rowData.deleted}
                  size="small"
                  onClick={handleConfirm(rowData)}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
        setCellProps: () => ({ style: { width: 130, textAlign: "right" } }),
      },
    },
  ];

  const options = {
    filterType: "multiselect",
    expandableRowsHeader: false,
    selectableRows: "none",
    // selectableRows: false,
    download: false,
    print: false,
    viewColumns: true,
    customToolbar: () => {
      return (
        <CustomToolbar
          handleClick={handleClickOpen(null)}
          handleClickCollection={handleClickOpenCollection(null)}
          handleReload={handleClickReload}
        />
      );
    },
    //Dense
    setTableProps: () => {
      return {
        padding: "default",
        size: "small",
      };
    },
    setRowProps: (row, dataIndex, _rowIndex) => {
      let deleted = data[dataIndex]?.deleted;

      return (
        deleted && {
          style: { backgroundColor: "Gainsboro" },
          title: "Deleted",
        }
      );
    },
    textLabels: {
      body: {
        noMatch: loading ? "loading..." : "Sorry, no matching records found",
      },
    },
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "420px",
    jumpToPage: true,
  };

  return (
    <>
      <NavBar />
      <Paper className={classes.administrationPaper}>
        {loading && <BorderLinearProgress />}
        <ConfirmDelete
          handleClose={handleCloseConfirm}
          handleDelete={handleDelete}
          message={`Are you sure to Delete the MenuItem with Name: ${menuItemSelected?.name}?`}
          open={openConfirm}
        />
        {open && (
          <MenuItemForm
            handleClose={handleClose}
            initialValues={menuItemSelected}
            isCollection={isCollection}
            isEdit={isEdit}
            open={open}
          />
        )}
        <MUIDataTable columns={columns} data={data} options={options} title={"Menu Item"} />
      </Paper>
    </>
  );
};

export default MenuItem;
